import {React} from '@vht/react-components/libs';
import {PropTypes} from '@vht/react-components/libs';
import {Container, Row, Col} from 'react-bootstrap';

export default function AuthLayout(props) {
  const {children} = props;

  return (
    <div className="invitation-layout">
      <Container fluid={true}>
        <Row className="content-wrapper">
          <Col xs={1} md={2} xl={3}></Col>
          <Col xs={10} md={8} xl={6} className="content">
            {children}
          </Col>
          <Col xs={1} md={2} xl={3}></Col>
        </Row>
      </Container>
    </div>
  );
}

AuthLayout.propTypes = {
  /** The component to render in the main content area. */
  children: PropTypes.node.isRequired,
};
